import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import imageConfig from '../config/images';
import '../styles/CheckoutPage.css';

const PaymentFailurePage: React.FC = () => {
  const [countdown, setCountdown] = useState<number>(10);
  const history = useHistory();
  const location = useLocation();
  
  // Get transaction ID from URL parameters
  const searchParams = new URLSearchParams(location.search);
  const transactionId = searchParams.get('order_id') || 'Unknown';
  const errorCode = searchParams.get('error_code') || '';
  const errorMessage = searchParams.get('error_message') || 'Unknown error occurred';
  
  // Handle countdown and redirect after failed purchase
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      
      return () => clearTimeout(timer);
    } else {
      // Redirect to video selection page
      history.replace('/box/video-selection');
    }
  }, [countdown, history]);

  const backgroundStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${imageConfig.backgroundImage || imageConfig.defaultBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    margin: 0,
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1
  };

  return (
    <>
      <div className="checkout-page-background" style={backgroundStyle}></div>
      <div className="checkout-page">
        <div className="checkout-container">
          <h1>Payment Failed</h1>
          
          <div className="error-message-container">
            <div className="error-icon">✗</div>
            <h2>Payment Not Completed</h2>
            <p>Your payment was not completed successfully.</p>
            
            {errorMessage && (
              <div className="payment-error-details">
                <p>Error: {errorMessage}</p>
                {errorCode && <p>Code: {errorCode}</p>}
              </div>
            )}
            
            <p>Transaction ID: {transactionId}</p>
            
            <p className="redirect-message" style={{ color: '#d9534f' }}>
              You will be redirected to the video selection page in {countdown} second{countdown !== 1 ? 's' : ''}...
            </p>
            
            <button 
              onClick={() => history.push('/box/checkout')}
              className="retry-button"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentFailurePage; 